import { AmiWatcher } from './watcher.js';

export default function AmiSubmitBox(parent) {
    var pub = {};
    var watcher = new AmiWatcher;
    var maxLengthValue = 0;
    var click = function(ev) {
        watcher.call(pub, [ev]);
    };

    var button = <input type="button" value="Send" id="sendmsg" onclick={ev => { click(ev); }} />;
    var curLength = <span>0</span>;
    var maxLength = <span>{maxLengthValue}</span>;
    var container = <div id="submitButtonContainer">
        <span id="messageLengthCounter">
            {curLength}/{maxLength}
        </span>
        {' '}
        {button}
    </div>;

    parent.appendChild(container);

    pub.click = click;
    pub.watch = function(callback) {
        watcher.watch(callback);
    };
    pub.unwatch = function(watcher) {
        watcher.unwatch(callback);
    };

    pub.setCurrentLength = function(num) {
        num = parseInt(num);
        curLength.textContent = num.toLocaleString();
        if(num >= maxLengthValue && !curLength.style.color)
            curLength.style.color = '#c00';
        else if(num < maxLengthValue && curLength.style.color)
            curLength.style.color = null;
    };
    pub.setMaxLength = function(num) {
        maxLengthValue = parseInt(num);
        maxLength.textContent = maxLengthValue.toLocaleString();
    };

    return pub;
};
